import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import process from '../WorkEnvironmentSurveyProcess.module.css';

/** While the risk is calculated after the survey has closed */
export const RiskStatusCard = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="risk-status-heading" className={process.card}>
      <div className={process.cardBody}>
        <Heading level={2} data-size="sm" id="risk-status-heading">
          {t('workEnvironmentRisk.calculating.title')}
        </Heading>
        <Paragraph>{t('workEnvironmentRisk.calculating.text')}</Paragraph>
      </div>
    </section>
  );
};
